/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Brazilian Portuguese (pt) · Contact page
   English is the source of truth in contact.html; this file supplies the
   Portuguese counterpart for each contact.* data-i18n key. Missing keys
   fall back to English automatically (see i18n.js).

   Brazilian Portuguese (pt-BR), not European. Use "você", gerund tenses,
   BR vocabulary (hidratante, tela, geladeira). No em dashes (use periods,
   commas, or the mid-dot · ). Standalone "serum" → "sérum".
═════════════════════════════════════════════════════════════════════ */
(function(){
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.pt = window.TD_I18N.pt || {};
  Object.assign(window.TD_I18N.pt, {

    /* ── Footer · extra link not on the homepage ── */
    'footer.learn.about': 'Sobre o Dr. Ronlán',

    /* ── Page head ── */
    'contact.eyebrow': 'Entre em contato',
    'contact.title': 'Dúvidas,<br>solicitações,<br><em>ou só um oi.</em>',
    'contact.intro': 'Solicitações de imprensa, pedidos de revendedores, dúvidas sobre rotina, ou qualquer coisa entre isso. Lemos cada mensagem. As respostas costumam chegar em até dois dias úteis.',

    /* ── Reach us ── */
    'contact.reach': 'Fale conosco',
    'contact.email.label': 'E-mail',
    'contact.email.meta': 'Ideal para perguntas detalhadas',
    'contact.phone.label': 'Telefone',
    'contact.phone.meta': 'Seg – sex · 9h–17h EST',
    'contact.address.label': 'Endereço',
    'contact.address.meta': 'Devoluções e correspondência',
    'contact.social.label': 'Encontre a gente nas redes sociais',

    /* ── Inquiry form ── */
    'contact.form.eyebrow': 'Enviar uma mensagem',
    'contact.form.name': 'Nome',
    'contact.form.subject': 'Assunto',
    'contact.form.email': 'Endereço de e-mail',
    'contact.form.message': 'Mensagem',
    'contact.form.send': 'Enviar',
    'contact.form.success': 'Obrigada pela sua mensagem · respondemos em 1 a 2 dias úteis.',

    /* ── Response windows ── */
    'contact.hours.eyebrow': 'Prazos de resposta',
    'contact.hours.email.label': 'E-mail',
    'contact.hours.email.val': 'Em até 2 dias úteis',
    'contact.hours.phone.label': 'Telefone',
    'contact.hours.phone.val': '9h–17h EST',
    'contact.hours.press.label': 'Imprensa',
    'contact.hours.press.val': 'Em até 1 dia útil',

    /* ── CTA ── */
    'contact.cta.title': 'Não sabe qual sérum é para você?',
    'contact.cta.body': 'O Discovery Kit contém os cinco sérums em tamanho de bolso. A maioria sabe em poucos dias.',
    'contact.cta.button': 'Garanta o Discovery Kit'

  });
})();
